import {
  Badge,
  BadgeProps,
  Box,
  BoxProps,
  Button,
  Center,
  Flex,
  HStack,
  Spacer,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Table,
  TableContainer,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  ThemeTypings,
  Tr,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { ClipText, CurrencyLabel } from '../components';
import { AfeBudgetSummaryTable } from './AfeBudgetSummaryTable';
import {
  AfeFormWorkflowDrawer,
  AfeFormWorkflowDrawerProps,
  AfeFormWorkflowStage,
} from './AfeFormWorkflowDrawer';
import { AfeResponse } from 'api/bindings/AfeResponse';
import { AfeTransactionSummaryResponse } from 'api/bindings/AfeTransactionSummaryResponse';

interface AfeBudgetStatusBadgeProps extends BadgeProps {
  redeemed: Date | string | undefined;
  cancelled: Date | string | undefined;
  size?: 'small' | 'normal';
}

const AfeBudgetStatusBadge = (props: AfeBudgetStatusBadgeProps) => {
  const { redeemed, cancelled, size = 'normal', ...rest } = props;
  let text = redeemed ? 'Approved' : cancelled ? 'Cancelled' : 'Pending';
  if (size === 'small') {
    text = text[0];
  }

  const color: ThemeTypings['colorSchemes'] = redeemed
    ? 'green'
    : cancelled
    ? 'red'
    : 'yellow';
  return (
    <HStack>
      {size === 'normal' && <Text as="b">Approval Status:</Text>}
      <Badge
        size={(size === 'normal' && 'lg') || 'sm'}
        colorScheme={color}
        variant="solid"
        {...rest}
      >
        {text}
      </Badge>
    </HStack>
  );
};
export interface AfeBudgetSectionProps extends BoxProps {
  afe: AfeResponse | undefined;
  transactions: AfeTransactionSummaryResponse[] | undefined;
}

export const AfeBudgetSection = (props: AfeBudgetSectionProps) => {
  const { afe, transactions, ...rest } = props;

  // State
  // const [isRevisionModalOpen, setIsRevisionModalOpen] = useState(false);
  const [revisionModal, setRevisionModal] =
    useState<Omit<AfeFormWorkflowDrawerProps, 'onClose' | 'onSubmit'>>();

  return (
    <Box {...rest}>
      {revisionModal && (
        <AfeFormWorkflowDrawer
          {...revisionModal}
          afe={afe}
          isOpen={true}
          onClose={() => setRevisionModal(undefined)}
        />
      )}
      <HStack py={4}>
        <Spacer />
        <Button
          colorScheme="blue"
          leftIcon={
            //@ts-ignore
            <FiPlus />
          }
          onClick={() =>
            setRevisionModal({
              afe,
              isOpen: true,
              initialStage: AfeFormWorkflowStage.revision,
            })
          }
        >
          Budget Revision
        </Button>
      </HStack>

      <Tabs orientation="vertical">
        <TabList pr={4}>
          <Tab>Summary</Tab>
          {[...(transactions || [])]
            // ?.sort(sortDateStrings((v) => v.createdAt))
            .map((sheet, i) => (
              <Tab key={i}>
                <Flex width="100%">
                  {/* <ApprovalsArrayIcon txn={sheet} /> */}
                  <AfeBudgetStatusBadge
                    redeemed={sheet.redeemed ?? ''}
                    cancelled={sheet.cancelled ?? ''}
                    size={'small'}
                  />
                  <Text pl={2} pr={2}>
                    {i + 1}:
                  </Text>
                  <ClipText
                    noOfLines={1}
                    text={sheet.name}
                    textAlign={'left'}
                    flexGrow={1}
                  />
                </Flex>
              </Tab>
            ))}
        </TabList>
        {/* Budget Sheets  */}
        <TabPanels>
          <TabPanel p={0}>
            <AfeBudgetSummaryTable txns={transactions} />
          </TabPanel>
          {[...(transactions || [])]
            // ?.sort(sortDateStrings((v) => v.createdAt))
            .map((sheet, i) => (
              <TabPanel key={i} p={0}>
                <Stack>
                  <Flex>
                    <TableContainer flexGrow={1}>
                      <HStack py={4}>
                        <AfeBudgetStatusBadge
                          redeemed={sheet.redeemed ?? ''}
                          cancelled={sheet.cancelled ?? ''}
                        />
                      </HStack>
                      <Table variant={'simple'}>
                        <Thead>
                          <Tr>
                            <Th>Account</Th>
                            <Th>Budget</Th>
                            <Th>Contingency</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {!sheet.lineItems.length && (
                            <Tr>
                              <Td colSpan={3}>
                                <Center>No Budgets Configured</Center>
                              </Td>
                            </Tr>
                          )}
                          {sheet.lineItems.map((r, i) => (
                            <Tr key={i}>
                              <Td>
                                {/* <SubAccountLabel value={r.subAccount} /> */}
                              </Td>
                              <Td>
                                <CurrencyLabel value={r.budgetedAmount} />
                              </Td>
                              <Td>
                                <CurrencyLabel value={r.contingencyAmount} />
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                    {/* {!sheet.redeemed && !sheet.cancelled && (
                      <>
                        <PendingApproversCard
                          approvals={sheet.approvals}
                          total={sheet.total}
                          requested={sheet.requested}
                          boxShadow={'0'}
                          pt={0}
                          pb={0}
                          headingProps={{ size: 'xs' }}
                        />
                      </>
                    )} */}
                  </Flex>
                </Stack>
              </TabPanel>
            ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
